<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销列表(详情)'}]"/>
        <div class="h-content">
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
                            border
                            max-height="500"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="id"
                                width="140"
                                :show-overflow-tooltip="true"
                                label="预测编码">
                        </el-table-column>
                        <el-table-column
                                prop="country"
                                width="100"
                                :show-overflow-tooltip="true"
                                label="国家名称">
                            <template slot-scope="scope">
                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                width="140"
                                :show-overflow-tooltip="true"
                                label="型号">
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="140"
                                :show-overflow-tooltip="true"
                                label="产品编码">
                        </el-table-column>
                        <el-table-column
                                prop="protype"
                                width="100"
                                label="型号属性"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                width="80"
                                :show-overflow-tooltip="true"
                                label="数量">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.proNumber}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="useNumber"
								width="100"
                                :show-overflow-tooltip="true"
                                label="可用数量">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.useNumber}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="useInventory"
                                width="130"
                                :show-overflow-tooltip="true"
                                label="使用库存数量">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.useInventory}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="stockStatus"
                                width="100"
                                label="库存状态">
                            <template slot-scope="scope">
                                <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="isSpecific"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="常规或改制">
                            <template slot-scope="scope">
                                <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReq"
                                :show-overflow-tooltip="true"
								min-width="180"
                                label="改制大类">
									<template slot-scope="scope">
										<div style="text-align: left;">
											{{scope.row.specificReq}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReform"
                                :show-overflow-tooltip="true"
                                min-width="180"
                                label="改制要求">
                            <template slot-scope="scope">
                                <div style="text-align: left;">{{scope.row.specificReform}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reformPriceRmb"
                                         :show-overflow-tooltip="true"
                                         width="100" label="单台加价(元)">
                            <template slot-scope="scope">
                                <div style="text-align: left;">{{scope.row.reformPriceRmb}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="forecastStatus"
                                :show-overflow-tooltip="true"
								width="100"
                                label="预测状态">
                            <template slot-scope="scope">
                                <dictname category="yuce_zhuangt"  :v="scope.row.forecastStatus"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="useMeg"
                                :show-overflow-tooltip="true"
								min-width="200"
                                label="占用预测库存信息">
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                :show-overflow-tooltip="true"
								min-width="200"
                                label="备注">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.remark}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="deliveryDate"
                                width="130"
                                :show-overflow-tooltip="true"
                                label="预计交货期">
                        </el-table-column>
                        <el-table-column
                                label="方案图纸"
                                width="140"
                                v-if="fajl"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brupload
                                        :refid="scope.row.id"
                                        reftype="WXYC_LKFJ"
                                        :showtime="false">
                                </brupload>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="施工确认单"
                                width="140"
                                v-if="fajl"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brupload
                                        :refid="scope.row.id"
                                        reftype="WXYC_SGQRD"
                                        :showtime="false">
                                </brupload>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="海尔标准配置"
                                width="140"
                                v-if="fajl"
                                :show-overflow-tooltip="true">
                            <template scope="scope">
                                <span v-if="scope.row.isStandard == '1'">是</span>
                                <span v-if="scope.row.isStandard == '2'">否</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="投标参数"
                                width="140"
                                v-if="fajl"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brupload
                                        :refid="scope.row.id"
                                        reftype="WXYC_TBCS"
                                        :showtime="false">
                                </brupload>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="renovate">返回</el-button>
            </div>
        </div>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
                tableData: [],
                q: {
                    id: '',
                },
                fajl: false,
            }
        },
        mounted() {

        },
        created() {
            this.query();
        },
        methods: {
            query() {
                this.q.id = this.$route.query.cid;
                ss.waixiao.showRevise(this.q).then(rd => {
                    this.tableData = rd;
                    for (var i = 0; i < this.tableData.length; i++) {
                        if(this.tableData[i].isLk == 1){
                            this.fajl = true;
                        }
                    }
                })
            },
            renovate() {
                this.$router.push({path:'/personal/dealCenter'});
            },
        }
    }
</script>